import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { RootState } from 'state/store';

const ProtectedRoute = ({ children }: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { orgId, propertyId } = useParams();

  const { isAuthenticated } = useSelector((state: RootState) => {
    return state.auth;
  });

  if (!isAuthenticated && orgId && propertyId) {
    navigate(`/${orgId}/${propertyId}${location.search}`, { replace: true });
    return null;
  }

  return children;
};

export default ProtectedRoute;
